export enum ValidationStatus {
  VALID = 'valid',
  PENDING = 'pending',
  NOT_VALID = 'not_valid',
  VALIDATED_BY_USER = 'validated_by_user',
}

export enum ValidationType {
  COST_VALIDATION_STATUS = 'costValidationStatus',
  GPM_VALIDATION_STATUS = 'gpmValidationStatus',
  MOQ_VALIDATION_STATUS = 'moqValidationStatus',
  ORDER_INCREMENT_VALIDATION_STATUS = 'orderIncrementValidationStatus',
  QUANTITY_UOM_VALIDATION_STATUS = 'quantityUomValidationStatus',
}
